module.exports = __webpack_public_path__ + "static/img/UA.a707557f.jpg";